const getPageDynamicData = ({ widgetName = '' }) => {
    if (__BROWSER__ && window.__COMBINED_DATA__) {
        const { widgets = [] } = window.__COMBINED_DATA__ || {}

        const rmaPageData = widgets.find(({ name }) => {
            const isRMA = name === widgetName
        return isRMA
        });
        return rmaPageData?.apiDetails || {};
    }
    return {}
}

export default getPageDynamicData;